import { Component, EventEmitter, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { ScheduleVehicle } from "../../../models/criteria";
import {cloneDeep} from 'lodash';

@Component({
    selector: 'app-schedule-vehicles-form',
    templateUrl: './schedule-vehicles-form.component.html',
    styleUrls: ['./schedule-vehicles-form.component.css'],
    standalone: false
})
export class ScheduleVehiclesFormComponent implements OnInit {
    @Output() saved = new EventEmitter<any>();
    scheduleVehiclesForm: UntypedFormGroup;
    existingScheduleVehicle: any;

    constructor(private readonly formBuilder: FormBuilder,
        private readonly translate: TranslateService,
        private readonly snackBar: MatSnackBar) {

    }
    ngOnInit(): void {
        this.clearForm();
        this.loadExistingScheduleVehicle();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.existingScheduleVehicle && changes.existingScheduleVehicle.currentValue) {
          this.loadExistingScheduleVehicle();
        }
      }
    clearForm(): void {
        this.scheduleVehiclesForm = this.formBuilder.group({
            manufacturer: ['', Validators.required],
            model: ['', Validators.required],
            type: [''],
            startYear: [0],
            endYear: [0]
        });
    }
    cancel() {
        this.clearForm();
        this.saved.next(null);
    }
    add(){
        if (this.scheduleVehiclesForm.invalid) {
            this.scheduleVehiclesForm.markAllAsTouched();
            const notification = this.translate.instant('@missingValues');
            const action = this.translate.instant('@gotItNow');
            this.snackBar.open(notification, action, { duration: 8555 });
            return;
          }
          var toReturn = new ScheduleVehicle();
          //get properties from form
          const manufacturer = this.scheduleVehiclesForm.get('manufacturer')?.value;
          const model = this.scheduleVehiclesForm.get('model')?.value;
          const type = this.scheduleVehiclesForm.get('type')?.value;
          const startYear = this.scheduleVehiclesForm.get('startYear')?.value;
          const endYear = this.scheduleVehiclesForm.get('endYear')?.value;
      
          toReturn.type = type;
          toReturn.manufacturer = manufacturer;
          toReturn.model = model;
          toReturn.startYear = startYear;
          toReturn.endYear = endYear;
                
          this.saved.emit(toReturn);
          this.clearForm();
    }
    loadExistingScheduleVehicle(): void {
        if (this.existingScheduleVehicle) {
          const scheduleVehicle = cloneDeep(this.existingScheduleVehicle);
          //set value from existing
          this.scheduleVehiclesForm.controls['manufacturer'].setValue(scheduleVehicle.manufacturer);
          this.scheduleVehiclesForm.controls['model'].setValue(scheduleVehicle.model);
          this.scheduleVehiclesForm.controls['type'].setValue(scheduleVehicle.type);
          this.scheduleVehiclesForm.controls['startYear'].setValue(scheduleVehicle.startYear);
          this.scheduleVehiclesForm.controls['endYear'].setValue(scheduleVehicle.endYear);
        }
      }
}